import "../../styles/screen.css"
import "../../styles/flex.css"
import "../../styles/texts.css"
import "./index.css"
import logo from "../../imgs/logo.svg"
import { ButtonHome } from "../Buttons"
import page from "../../imgs/page.svg"
import { useState } from "react"
import { Header } from "../Header"
import { CardFinancialSummary, CardSendValue } from "../Card"


const Home = ()=>{

    let listLocalStroage = localStorage.getItem("list")
    listLocalStroage = JSON.parse(listLocalStroage)

    if(listLocalStroage === null){
        listLocalStroage = []
    }

    let [list, setList] = useState(listLocalStroage)
    let [listFilter, setFilter] = useState(list)

    let [nav, setNav] = useState("Todos")

    const sendValue = (e)=> {
        e.preventDefault()
        let random = Math.floor(Math.random() * 1000)
        localStorage.setItem('list', JSON.stringify([...list, {"description": e.target[0].value, "value": e.target[1].value, "type": e.target[2].value, "id":random}]));
        setList([...list, {"description": e.target[0].value, "value": e.target[1].value, "type": e.target[2].value, "id":random}]); 
        setFilter([...list, {"description": e.target[0].value, "value": e.target[1].value, "type": e.target[2].value, "id":random}]);
        setNav("Todos")
        e.target[0].value = ""
        e.target[1].value = ""
    }
 
    const changeNav = (e)=>{
        if(e.target.innerText === "Todos"){
            setFilter(list)
            setNav("Todos")
        }else if(e.target.innerText === "Entradas"){
            setFilter(list.filter((elem)=>elem.type === "Entrada"))
            setNav("Entradas")
        }else if(e.target.innerText === "Despesas"){
            setFilter(list.filter((elem)=>elem.type === "Despesa"))
            setNav("Despesas")
        }
    }

    const deletedCard = (e)=>{
        let number = parseInt(e.target.dataset.id)
        let listCards = list.filter((elem)=> elem.id !== number)
        localStorage.setItem('list', JSON.stringify(listCards));    
        setList(listCards); 
        setFilter(listCards);
        setNav("Todos")
    }

    const BackgroundClear = ()=>{
        const BodyBackground = document.querySelector('body');
        BodyBackground.style.background="var(--color-grey-1)"
    }

    const BackgroundDark = ()=>{
        const BodyBackground = document.querySelector('body');
        BodyBackground.style.background="var(--color-grey-4)"
    }
    
    const [value, setValue] = useState(true);
    
    const changePageStart = () => {setValue(false)}
    const changePageBack = () => {setValue(true)}

   

   return(
        value ?(
            <>
            {BackgroundDark()}
                <main className="screen-size-100 flex items-center justify-center">
                    <div className="default-screen-size flex items-center justify-center">
                        <div className="container cont-resposive-home">
                            <section className="first-section flex items-start justify-center flex-column gap-medium">
                                <img src={logo} alt="logo" className="img-logo"/>
                                <h1 className="font-size-1 font-weight-1 font-color-4">Centralize <br/> o controle das suas finanças</h1>
                                <p className="font-size-4 font-weight-2 font-color-4">de forma rápida e segura</p>
                                <ButtonHome text="Iniciar" event={changePageStart}/> 
                            </section>
                            <section className="second-section flex items-center justify-start">
                                <img src={page} alt="page" className="img-page"/>
                            </section>
                        </div>
                    </div>
                </main>
            </>
        )
        :(
            <>
                {BackgroundClear()}
                <Header eventFunction={changePageBack} />
                <main className="screen-size-100 flex items-center justify-center">
                    <div className="default-screen-size flex items-center justify-center">
                        <div className="container cont-flex">
                            <CardSendValue event={sendValue}/>
                            <CardFinancialSummary list={listFilter} eventNav={changeNav} eventDeleted={deletedCard} nav={nav}/>
                        </div> 
                    </div>
                </main>
            </>
            

           
        )
   )
}

export default Home

/*Contendo os seguintes componentes: Button, Input, Select, Header, Card e Total.*/